import { DefaultTemplate, COR, CORES_SIM_NAO } from './types';

// ============================================================
// FINANCEIRO — Contas a Pagar, Contas a Receber, Reembolsos,
// Fechamento Mensal
// ============================================================

const contasPagar: DefaultTemplate = {
  id: 'tpl_contas_pagar',
  name: 'Contas a Pagar',
  descricao: 'Da solicitação da despesa ao comprovante arquivado, com alçada de aprovação por valor, agendamento por vencimento e trilha completa para auditoria. SLA configurado em todas as etapas.',
  categoria: 'financeiro',
  icone: '💸',
  etiquetas: [
    { nome: 'Recorrente', cor: COR.azul },
    { nome: 'Urgente', cor: COR.vermelho },
    { nome: 'Contrato', cor: COR.roxo },
    { nome: 'Imposto', cor: COR.amarelo },
  ],
  etapas: [
    {
      id: 'cp_e1', nome: 'Solicitação',
      tempoMaximoHoras: 8,
      camposVisiveisNoCard: ['cp_c1', 'cp_c3', 'cp_c6'],
      permiteMoverPara: ['cp_e2'],
      campos: [
        { id: 'cp_c1', nome: 'Fornecedor', tipo: 'texto', obrigatorio: true, usarComoTitulo: true },
        { id: 'cp_c2', nome: 'CNPJ do Fornecedor', tipo: 'texto', obrigatorio: false },
        { id: 'cp_c3', nome: 'Valor', tipo: 'valor', obrigatorio: true },
        { id: 'cp_c4', nome: 'Descrição da Despesa', tipo: 'texto_longo', obrigatorio: true },
        { id: 'cp_c5', nome: 'Nota Fiscal / Boleto', tipo: 'anexo', obrigatorio: false },
        {
          id: 'cp_c6', nome: 'Categoria', tipo: 'lista', obrigatorio: true,
          opcoes: ['Aluguel', 'Utilities', 'Material de escritório', 'Serviços', 'Marketing', 'Software / SaaS', 'Impostos', 'Frete', 'Outros'],
          coresOpcoes: { 'Aluguel': COR.roxo, 'Utilities': COR.ciano, 'Impostos': COR.amarelo, 'Software / SaaS': COR.azul, 'Serviços': COR.verde },
        },
        { id: 'cp_c7', nome: 'Centro de Custo', tipo: 'lista', obrigatorio: true, opcoes: ['Administrativo', 'Comercial', 'Operações', 'TI', 'Marketing', 'RH'] },
        { id: 'cp_c8', nome: 'Data de Vencimento', tipo: 'data_vencimento', obrigatorio: true },
        { id: 'cp_c9', nome: 'Despesa recorrente?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
      ],
    },
    {
      id: 'cp_e2', nome: 'Aprovação do Gestor',
      tempoMaximoHoras: 24,
      camposVisiveisNoCard: ['cp_c1', 'cp_c3', 'cp_c10'],
      permiteMoverPara: ['cp_e3', 'cp_e4', 'cp_e7'],
      limparCamposAoRetornar: ['cp_c10', 'cp_c11'],
      campos: [
        { id: 'cp_c10', nome: 'Aprovado?', tipo: 'lista', obrigatorio: true, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'cp_c11', nome: 'Parecer do Aprovador', tipo: 'texto_longo', obrigatorio: false },
        { id: 'cp_c12', nome: 'Verba prevista no orçamento?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
      ],
    },
    {
      id: 'cp_e3', nome: 'Aprovação da Diretoria',
      tempoMaximoHoras: 48,
      camposVisiveisNoCard: ['cp_c1', 'cp_c3', 'cp_c13'],
      permiteMoverPara: ['cp_e4', 'cp_e7'],
      permiteCriarCards: false,
      campos: [
        { id: 'cp_c13', nome: 'Aprovado pela Diretoria?', tipo: 'lista', obrigatorio: true, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'cp_c14', nome: 'Justificativa da Diretoria', tipo: 'texto_longo', obrigatorio: false },
        { id: 'cp_c15', nome: 'Alçada', tipo: 'texto_informativo', obrigatorio: false, textoInformativo: 'Esta etapa recebe automaticamente as despesas acima de R$ 5.000. Ajuste o valor da alçada na automação "Alçada: acima de 5 mil vai para Diretoria".', ocultarTitulo: true },
      ],
    },
    {
      id: 'cp_e4', nome: 'Agendamento de Pagamento',
      tempoMaximoHoras: 24,
      ordenacaoCards: 'vencimento_proximo',
      camposVisiveisNoCard: ['cp_c1', 'cp_c3', 'cp_c8', 'cp_c16'],
      permiteMoverPara: ['cp_e5'],
      permiteCriarCards: false,
      campos: [
        { id: 'cp_c16', nome: 'Forma de Pagamento', tipo: 'lista', obrigatorio: true, opcoes: ['PIX', 'Boleto', 'Transferência (TED)', 'Cartão Corporativo', 'Débito Automático'], coresOpcoes: { 'PIX': COR.verde, 'Boleto': COR.azul, 'Cartão Corporativo': COR.roxo } },
        { id: 'cp_c17', nome: 'Dados Bancários / Chave PIX', tipo: 'texto_longo', obrigatorio: false },
        { id: 'cp_c18', nome: 'Data Programada', tipo: 'data', obrigatorio: true },
        { id: 'cp_c19', nome: 'Nº do Documento / Título', tipo: 'texto', obrigatorio: false },
      ],
    },
    {
      id: 'cp_e5', nome: 'Pago',
      tempoMaximoHoras: 8,
      camposVisiveisNoCard: ['cp_c1', 'cp_c3', 'cp_c21'],
      permiteMoverPara: ['cp_e6'],
      permiteCriarCards: false,
      campos: [
        { id: 'cp_c20', nome: 'Comprovante de Pagamento', tipo: 'anexo', obrigatorio: true },
        { id: 'cp_c21', nome: 'Data do Pagamento', tipo: 'data', obrigatorio: true },
        { id: 'cp_c22', nome: 'Valor Efetivamente Pago', tipo: 'valor', obrigatorio: false },
        { id: 'cp_c23', nome: 'Conta de Saída', tipo: 'lista', obrigatorio: false, opcoes: ['Banco Principal', 'Banco Secundário', 'Caixa'] },
      ],
    },
    {
      id: 'cp_e6', nome: 'Conciliado',
      camposVisiveisNoCard: ['cp_c1', 'cp_c3'],
      permiteCriarCards: false,
      campos: [
        { id: 'cp_c24', nome: 'Conferido no extrato?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'cp_c25', nome: 'Competência Contábil', tipo: 'texto', obrigatorio: false },
      ],
    },
    {
      id: 'cp_e7', nome: 'Reprovado',
      camposVisiveisNoCard: ['cp_c1', 'cp_c3', 'cp_c26'],
      permiteMoverPara: ['cp_e1'],
      permiteCriarCards: false,
      campos: [
        { id: 'cp_c26', nome: 'Motivo da Reprovação', tipo: 'texto_longo', obrigatorio: true },
      ],
    },
  ],
  automacoes: [
    {
      tipo: 'mover',
      nome: 'Aprovado pelo gestor segue para agendamento',
      etapaOrigemId: 'cp_e2',
      condicao: { campoId: 'cp_c10', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'cp_e4',
      etapaDestinoSenaoId: 'cp_e7',
    },
    {
      tipo: 'mover',
      nome: 'Diretoria aprovou vai para agendamento',
      etapaOrigemId: 'cp_e3',
      condicao: { campoId: 'cp_c13', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'cp_e4',
      etapaDestinoSenaoId: 'cp_e7',
    },
    {
      tipo: 'mover',
      nome: 'Comprovante anexado marca como Pago',
      etapaOrigemId: 'cp_e5',
      condicao: { campoId: 'cp_c20', operador: 'preenchido' },
      etapaDestinoId: 'cp_e6',
    },
    {
      tipo: 'exibir_ocultar',
      nome: 'Mostrar parecer só quando reprovar',
      etapaOrigemId: 'cp_e2',
      condicao: { campoId: 'cp_c10', operador: 'igual', valor: 'Não' },
      camposAfetadosIds: ['cp_c11'],
    },
  ],
  cards: [
    { id: 'cp_card1', titulo: 'Aluguel do escritório - Março', etapaId: 'cp_e4', etiquetas: ['Recorrente', 'Contrato'], valores: { cp_c1: 'Imobiliária Central', cp_c3: 4500, cp_c6: 'Aluguel', cp_c7: 'Administrativo', cp_c9: 'Sim', cp_c16: 'Transferência (TED)' } },
    { id: 'cp_card2', titulo: 'Serviço de limpeza mensal', etapaId: 'cp_e2', etiquetas: ['Recorrente'], valores: { cp_c1: 'Clean Master Ltda', cp_c3: 1200, cp_c6: 'Serviços', cp_c7: 'Administrativo', cp_c9: 'Sim' } },
    { id: 'cp_card3', titulo: 'Licenças Microsoft 365 - anual', etapaId: 'cp_e3', etiquetas: ['Contrato'], valores: { cp_c1: 'Microsoft Brasil', cp_c3: 18400, cp_c6: 'Software / SaaS', cp_c7: 'TI' } },
    { id: 'cp_card4', titulo: 'Papel e toner para impressora', etapaId: 'cp_e1', valores: { cp_c1: 'Kalunga', cp_c3: 350, cp_c6: 'Material de escritório', cp_c7: 'Administrativo' } },
    { id: 'cp_card5', titulo: 'Conta de energia elétrica', etapaId: 'cp_e5', etiquetas: ['Recorrente', 'Urgente'], valores: { cp_c1: 'CPFL Energia', cp_c3: 870, cp_c6: 'Utilities', cp_c7: 'Operações', cp_c16: 'Débito Automático' } },
    { id: 'cp_card6', titulo: 'DAS - Simples Nacional', etapaId: 'cp_e6', etiquetas: ['Imposto', 'Recorrente'], valores: { cp_c1: 'Receita Federal', cp_c3: 3260, cp_c6: 'Impostos', cp_c7: 'Administrativo' } },
    { id: 'cp_card7', titulo: 'Consultoria de marketing (cancelada)', etapaId: 'cp_e7', valores: { cp_c1: 'Agência Nova', cp_c3: 7800, cp_c6: 'Marketing', cp_c7: 'Marketing', cp_c26: 'Fora do orçamento aprovado para o trimestre.' } },
  ],
  tour: [
    '💸 Todo pagamento da empresa passa por aqui — com alçada, prazo e comprovante.',
    '1️⃣ "Solicitação": quem precisa pagar registra fornecedor, valor, categoria e vencimento.',
    '2️⃣ "Aprovação do Gestor": o gestor da área valida. Reprovou? o card vai sozinho para "Reprovado".',
    '3️⃣ "Aprovação da Diretoria": só recebe despesas de valor alto — é a sua alçada, ajustável na automação.',
    '4️⃣ "Agendamento": tesouraria define forma e data. A coluna já vem ordenada por vencimento mais próximo.',
    '5️⃣ "Pago" → anexou o comprovante, o card caminha sozinho para "Conciliado".',
    '⏱️ Cada etapa já tem SLA em horas: o Dashboard mostra na hora onde o processo está travando.',
    '🏷️ Use as etiquetas Recorrente, Urgente, Contrato e Imposto para achar tudo rápido.',
  ],
  etapasDicas: [
    { quemFaz: 'Qualquer colaborador que precise pagar algo', objetivo: 'Registrar a despesa com fornecedor, valor, categoria e vencimento antes que o prazo aperte.', automacoes: ['O campo Fornecedor já vira o título do cartão automaticamente'], conexoes: ['Ligue ao fluxo de Compras: pedido recebido gera a conta a pagar automaticamente'], ondeConfigurar: 'Conexões entre Fluxos > Compras > etapa "Recebimento" > criar card aqui' },
    { quemFaz: 'Gestor da área / Centro de custo', objetivo: 'Validar se a despesa é legítima e está dentro do orçamento.', automacoes: ['Já configurado: "Sim" segue para Agendamento, "Não" vai para Reprovado', 'Já configurado: o campo Parecer só aparece quando você reprova'], ondeConfigurar: 'Automações > "Aprovado pelo gestor segue para agendamento"' },
    { quemFaz: 'Diretoria / Sócios', objetivo: 'Segunda alçada para despesas de valor alto — proteção contra gasto relevante sem duas assinaturas.', automacoes: ['Ajuste o valor de corte da alçada na automação de mover por valor'], ondeConfigurar: 'Automações > condição campo "Valor" > operador "maior" > defina o corte' },
    { quemFaz: 'Tesouraria / Analista Financeiro', objetivo: 'Programar a saída de caixa: forma de pagamento, data e dados bancários.', automacoes: ['Alerta de SLA avisa quando o card passa de 24h aqui'], conexoes: ['Ligue a Contas a Receber para comparar entradas e saídas do mesmo período'], ondeConfigurar: 'Configuração da Etapa > SLA e Alertas' },
    { quemFaz: 'Tesouraria', objetivo: 'Executar o pagamento e guardar o comprovante — rastreabilidade para auditoria.', automacoes: ['Já configurado: anexou o comprovante, o card vai para Conciliado'], ondeConfigurar: 'Automações > "Comprovante anexado marca como Pago"' },
    { quemFaz: 'Contabilidade', objetivo: 'Bater o pagamento com o extrato e fechar a competência contábil.', conexoes: ['Ligue ao fluxo de Fechamento Mensal para consolidar a competência'], ondeConfigurar: 'Conexões entre Fluxos' },
    { quemFaz: 'Solicitante (recebe de volta)', objetivo: 'Entender o motivo da recusa e corrigir a solicitação, se for o caso.', automacoes: ['O card pode voltar para "Solicitação" depois de ajustado'], ondeConfigurar: 'Configuração da Etapa > Transições permitidas' },
  ],
};

const contasReceber: DefaultTemplate = {
  id: 'tpl_contas_receber',
  name: 'Contas a Receber',
  descricao: 'Faturamento, envio da cobrança, régua de acompanhamento e baixa do recebimento — com trilha separada para inadimplência e negociação. Enxergue o que vai entrar no caixa e o que travou.',
  categoria: 'financeiro',
  icone: '💰',
  etiquetas: [
    { nome: 'Cliente novo', cor: COR.azul },
    { nome: 'Contrato', cor: COR.roxo },
    { nome: 'Risco', cor: COR.vermelho },
    { nome: 'Parcelado', cor: COR.ciano },
  ],
  etapas: [
    {
      id: 'cr_e1', nome: 'A Faturar',
      tempoMaximoHoras: 24,
      camposVisiveisNoCard: ['cr_c1', 'cr_c3', 'cr_c6'],
      permiteMoverPara: ['cr_e2'],
      campos: [
        { id: 'cr_c1', nome: 'Cliente', tipo: 'texto', obrigatorio: true, usarComoTitulo: true },
        { id: 'cr_c2', nome: 'CNPJ / CPF', tipo: 'texto', obrigatorio: false },
        { id: 'cr_c3', nome: 'Valor', tipo: 'valor', obrigatorio: true },
        { id: 'cr_c4', nome: 'Descrição do Serviço / Produto', tipo: 'texto_longo', obrigatorio: true },
        { id: 'cr_c5', nome: 'Contato para Cobrança', tipo: 'telefone', obrigatorio: false },
        { id: 'cr_c6', nome: 'Tipo de Cobrança', tipo: 'lista', obrigatorio: true, opcoes: ['Avulsa', 'Recorrente (mensal)', 'Parcelada'], coresOpcoes: { 'Recorrente (mensal)': COR.roxo, 'Parcelada': COR.ciano, 'Avulsa': COR.cinza } },
        { id: 'cr_c7', nome: 'Data de Vencimento', tipo: 'data_vencimento', obrigatorio: true },
      ],
    },
    {
      id: 'cr_e2', nome: 'Nota Fiscal Emitida',
      tempoMaximoHoras: 24,
      camposVisiveisNoCard: ['cr_c1', 'cr_c3', 'cr_c8'],
      permiteMoverPara: ['cr_e3'],
      permiteCriarCards: false,
      campos: [
        { id: 'cr_c8', nome: 'Número da NF', tipo: 'texto', obrigatorio: true },
        { id: 'cr_c9', nome: 'PDF da Nota Fiscal', tipo: 'anexo', obrigatorio: false },
        { id: 'cr_c10', nome: 'Data de Emissão', tipo: 'data', obrigatorio: true },
      ],
    },
    {
      id: 'cr_e3', nome: 'Cobrança Enviada',
      tempoMaximoHoras: 8,
      camposVisiveisNoCard: ['cr_c1', 'cr_c3', 'cr_c7'],
      permiteMoverPara: ['cr_e4'],
      permiteCriarCards: false,
      campos: [
        { id: 'cr_c11', nome: 'Canal de Envio', tipo: 'lista', obrigatorio: true, opcoes: ['E-mail', 'WhatsApp', 'Portal do Cliente', 'Correio'] },
        { id: 'cr_c12', nome: 'Data do Envio', tipo: 'data', obrigatorio: true },
        { id: 'cr_c13', nome: 'Boleto / Link de Pagamento', tipo: 'anexo', obrigatorio: false },
      ],
    },
    {
      id: 'cr_e4', nome: 'Aguardando Pagamento',
      tempoMaximoHoras: 720,
      ordenacaoCards: 'vencimento_proximo',
      camposVisiveisNoCard: ['cr_c1', 'cr_c3', 'cr_c7'],
      permiteMoverPara: ['cr_e5', 'cr_e6'],
      permiteCriarCards: false,
      campos: [
        { id: 'cr_c14', nome: 'Lembrete enviado?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'cr_c15', nome: 'Observações do Contato', tipo: 'texto_longo', obrigatorio: false },
      ],
    },
    {
      id: 'cr_e5', nome: 'Recebido',
      camposVisiveisNoCard: ['cr_c1', 'cr_c3', 'cr_c17'],
      permiteCriarCards: false,
      campos: [
        { id: 'cr_c16', nome: 'Comprovante de Recebimento', tipo: 'anexo', obrigatorio: false },
        { id: 'cr_c17', nome: 'Data do Recebimento', tipo: 'data', obrigatorio: true },
        { id: 'cr_c18', nome: 'Valor Recebido', tipo: 'valor', obrigatorio: true },
      ],
    },
    {
      id: 'cr_e6', nome: 'Inadimplente',
      tempoMaximoHoras: 48,
      camposVisiveisNoCard: ['cr_c1', 'cr_c3', 'cr_c19'],
      permiteMoverPara: ['cr_e7', 'cr_e5'],
      permiteCriarCards: false,
      campos: [
        { id: 'cr_c19', nome: 'Dias em Atraso', tipo: 'numero', obrigatorio: false },
        { id: 'cr_c20', nome: 'Ação de Cobrança', tipo: 'lista', obrigatorio: true, opcoes: ['Contato amigável', 'Notificação formal', 'Negativação', 'Protesto', 'Jurídico'], coresOpcoes: { 'Contato amigável': COR.azul, 'Notificação formal': COR.amarelo, 'Negativação': COR.vermelho, 'Jurídico': COR.vermelho } },
        { id: 'cr_c21', nome: 'Histórico de Tentativas', tipo: 'texto_longo', obrigatorio: false },
      ],
    },
    {
      id: 'cr_e7', nome: 'Em Negociação',
      tempoMaximoHoras: 168,
      camposVisiveisNoCard: ['cr_c1', 'cr_c3', 'cr_c22'],
      // cr_e4 precisa estar liberado: a automação "Acordo aceito" devolve o card para lá
      permiteMoverPara: ['cr_e4', 'cr_e5', 'cr_e6'],
      permiteCriarCards: false,
      campos: [
        { id: 'cr_c22', nome: 'Proposta de Acordo', tipo: 'texto_longo', obrigatorio: true },
        { id: 'cr_c23', nome: 'Novo Vencimento', tipo: 'data_vencimento', obrigatorio: false },
        { id: 'cr_c24', nome: 'Desconto Concedido', tipo: 'valor', obrigatorio: false },
        { id: 'cr_c25', nome: 'Acordo aceito?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
      ],
    },
  ],
  automacoes: [
    {
      tipo: 'mover',
      nome: 'NF emitida segue para envio da cobrança',
      etapaOrigemId: 'cr_e2',
      condicao: { campoId: 'cr_c8', operador: 'preenchido' },
      etapaDestinoId: 'cr_e3',
    },
    {
      tipo: 'mover',
      nome: 'Cobrança enviada vai aguardar pagamento',
      etapaOrigemId: 'cr_e3',
      condicao: { campoId: 'cr_c12', operador: 'preenchido' },
      etapaDestinoId: 'cr_e4',
    },
    {
      tipo: 'mover',
      nome: 'Acordo aceito volta para aguardando pagamento',
      etapaOrigemId: 'cr_e7',
      condicao: { campoId: 'cr_c25', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'cr_e4',
    },
  ],
  cards: [
    { id: 'cr_card1', titulo: 'Mensalidade de suporte - Abril', etapaId: 'cr_e4', etiquetas: ['Contrato'], valores: { cr_c1: 'Tech Solutions Ltda', cr_c3: 8500, cr_c6: 'Recorrente (mensal)' } },
    { id: 'cr_card2', titulo: 'Implantação do sistema', etapaId: 'cr_e1', etiquetas: ['Cliente novo'], valores: { cr_c1: 'Comércio Silva ME', cr_c3: 24000, cr_c6: 'Parcelada' } },
    { id: 'cr_card3', titulo: 'Consultoria estratégica', etapaId: 'cr_e5', valores: { cr_c1: 'Grupo Andrade', cr_c3: 15000, cr_c6: 'Avulsa', cr_c18: 15000 } },
    { id: 'cr_card4', titulo: 'Licenças - 1º trimestre', etapaId: 'cr_e6', etiquetas: ['Risco'], valores: { cr_c1: 'Distribuidora Norte', cr_c3: 12300, cr_c19: 47, cr_c20: 'Notificação formal' } },
    { id: 'cr_card5', titulo: 'Projeto de migração', etapaId: 'cr_e7', etiquetas: ['Risco', 'Parcelado'], valores: { cr_c1: 'Indústria Metalpar', cr_c3: 56000, cr_c22: 'Parcelar em 4x com entrada de 20%.' } },
    { id: 'cr_card6', titulo: 'Treinamento in company', etapaId: 'cr_e2', valores: { cr_c1: 'Rede Farmácia Vida', cr_c3: 9800, cr_c6: 'Avulsa' } },
  ],
  tour: [
    '💰 Aqui você enxerga tudo que a empresa tem para receber — e o que travou.',
    '1️⃣ "A Faturar": a venda aconteceu, falta faturar. Registre cliente, valor e vencimento.',
    '2️⃣ "Nota Fiscal Emitida": preencheu o número da NF, o card anda sozinho.',
    '3️⃣ "Cobrança Enviada": registre por onde foi (e-mail, WhatsApp, portal).',
    '4️⃣ "Aguardando Pagamento": ordenada por vencimento mais próximo — cobre antes de virar problema.',
    '5️⃣ Não pagou? "Inadimplente" e, se houver conversa, "Em Negociação" com proposta de acordo.',
    '✅ Acordo aceito devolve o card para "Aguardando Pagamento" automaticamente.',
    '⏱️ O SLA de 30 dias em "Aguardando Pagamento" acende o alerta de atraso no Dashboard.',
  ],
  etapasDicas: [
    { quemFaz: 'Faturamento / Comercial', objetivo: 'Não deixar venda fechada sem virar cobrança.', conexoes: ['Ligue ao Pipeline de Vendas: negócio "Ganho" cria o faturamento aqui automaticamente'], ondeConfigurar: 'Conexões entre Fluxos > Pipeline de Vendas > etapa "Ganho"' },
    { quemFaz: 'Fiscal / Contabilidade', objetivo: 'Emitir a NF e guardar o PDF junto do card.', automacoes: ['Já configurado: número da NF preenchido move o card adiante'], ondeConfigurar: 'Automações > "NF emitida segue para envio da cobrança"' },
    { quemFaz: 'Cobrança / Financeiro', objetivo: 'Garantir que o cliente recebeu boleto ou link — sem isso, não existe atraso legítimo.', automacoes: ['Já configurado: data de envio preenchida move para Aguardando Pagamento'], ondeConfigurar: 'Automações > "Cobrança enviada vai aguardar pagamento"' },
    { quemFaz: 'Cobrança', objetivo: 'Acompanhar prazos e cobrar antes do vencimento.', automacoes: ['Ative alerta de WhatsApp no SLA para avisar o responsável quando atrasar'], ondeConfigurar: 'Configuração da Etapa > Alerta SLA WhatsApp' },
    { quemFaz: 'Financeiro', objetivo: 'Dar baixa com data e valor recebido — base da conciliação.', ondeConfigurar: 'Configuração da Etapa > Campos visíveis no card' },
    { quemFaz: 'Cobrança / Jurídico', objetivo: 'Escalonar a cobrança de forma registrada: do contato amigável ao jurídico.', conexoes: ['Ligue a Processos Jurídicos quando a ação passar para a via judicial'], ondeConfigurar: 'Conexões entre Fluxos > Processos Jurídicos' },
    { quemFaz: 'Gerente Financeiro', objetivo: 'Negociar prazo ou desconto com alçada e registro do que foi combinado.', automacoes: ['Já configurado: acordo aceito devolve o card para Aguardando Pagamento'], ondeConfigurar: 'Automações > "Acordo aceito volta para aguardando pagamento"' },
  ],
};

const reembolsos: DefaultTemplate = {
  id: 'tpl_reembolsos',
  name: 'Reembolso de Despesas',
  descricao: 'Colaborador pediu reembolso? Aqui ele registra com comprovante, o gestor aprova pela política, o financeiro paga e tudo fica auditável. Com política visível dentro do próprio cartão.',
  categoria: 'financeiro',
  icone: '🧾',
  etiquetas: [
    { nome: 'Viagem', cor: COR.azul },
    { nome: 'Cliente', cor: COR.roxo },
    { nome: 'Fora da política', cor: COR.vermelho },
  ],
  etapas: [
    {
      id: 'rb_e1', nome: 'Solicitação',
      tempoMaximoHoras: 8,
      camposVisiveisNoCard: ['rb_c1', 'rb_c4', 'rb_c3'],
      permiteMoverPara: ['rb_e2'],
      campos: [
        { id: 'rb_c0', nome: 'Política', tipo: 'texto_informativo', obrigatorio: false, ocultarTitulo: true, textoInformativo: '📌 Reembolso só com comprovante legível e em até 30 dias da despesa. Refeição até R$ 60/dia, deslocamento por km rodado.' },
        { id: 'rb_c1', nome: 'Colaborador', tipo: 'texto', obrigatorio: true, usarComoTitulo: true },
        { id: 'rb_c2', nome: 'Departamento', tipo: 'lista', obrigatorio: true, opcoes: ['Administrativo', 'Comercial', 'Operações', 'TI', 'Marketing', 'RH'] },
        { id: 'rb_c3', nome: 'Valor Solicitado', tipo: 'valor', obrigatorio: true },
        { id: 'rb_c4', nome: 'Tipo de Despesa', tipo: 'lista', obrigatorio: true, opcoes: ['Alimentação', 'Transporte / Combustível', 'Hospedagem', 'Material', 'Estacionamento / Pedágio', 'Outros'], coresOpcoes: { 'Alimentação': COR.verde, 'Transporte / Combustível': COR.azul, 'Hospedagem': COR.roxo, 'Outros': COR.cinza } },
        { id: 'rb_c5', nome: 'Data da Despesa', tipo: 'data', obrigatorio: true },
        { id: 'rb_c6', nome: 'Comprovante', tipo: 'anexo', obrigatorio: true },
        { id: 'rb_c7', nome: 'Justificativa', tipo: 'texto_longo', obrigatorio: true },
        { id: 'rb_c8', nome: 'Chave PIX / Conta', tipo: 'texto', obrigatorio: true },
      ],
    },
    {
      id: 'rb_e2', nome: 'Análise do Gestor',
      tempoMaximoHoras: 24,
      camposVisiveisNoCard: ['rb_c1', 'rb_c3', 'rb_c9'],
      permiteMoverPara: ['rb_e3', 'rb_e5'],
      limparCamposAoRetornar: ['rb_c9', 'rb_c10'],
      permiteCriarCards: false,
      campos: [
        { id: 'rb_c9', nome: 'Aprovado?', tipo: 'lista', obrigatorio: true, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'rb_c10', nome: 'Parecer do Gestor', tipo: 'texto_longo', obrigatorio: false },
        { id: 'rb_c11', nome: 'Dentro da política?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'rb_c12', nome: 'Valor Aprovado', tipo: 'valor', obrigatorio: false },
      ],
    },
    {
      id: 'rb_e3', nome: 'Processamento Financeiro',
      tempoMaximoHoras: 48,
      ordenacaoCards: 'mais_antigo',
      camposVisiveisNoCard: ['rb_c1', 'rb_c12', 'rb_c13'],
      permiteMoverPara: ['rb_e4'],
      permiteCriarCards: false,
      campos: [
        { id: 'rb_c13', nome: 'Data Programada de Pagamento', tipo: 'data', obrigatorio: true },
        { id: 'rb_c14', nome: 'Pagar junto com a folha?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
      ],
    },
    {
      id: 'rb_e4', nome: 'Reembolsado',
      camposVisiveisNoCard: ['rb_c1', 'rb_c12'],
      permiteCriarCards: false,
      campos: [
        { id: 'rb_c15', nome: 'Comprovante de Transferência', tipo: 'anexo', obrigatorio: true },
        { id: 'rb_c16', nome: 'Data do Pagamento', tipo: 'data', obrigatorio: true },
      ],
    },
    {
      id: 'rb_e5', nome: 'Recusado',
      camposVisiveisNoCard: ['rb_c1', 'rb_c3', 'rb_c17'],
      permiteMoverPara: ['rb_e1'],
      permiteCriarCards: false,
      campos: [
        { id: 'rb_c17', nome: 'Motivo da Recusa', tipo: 'texto_longo', obrigatorio: true },
      ],
    },
  ],
  automacoes: [
    {
      tipo: 'mover',
      nome: 'Aprovado segue para o financeiro',
      etapaOrigemId: 'rb_e2',
      condicao: { campoId: 'rb_c9', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'rb_e3',
      etapaDestinoSenaoId: 'rb_e5',
    },
    {
      tipo: 'mover',
      nome: 'Pagamento programado conclui o reembolso',
      etapaOrigemId: 'rb_e3',
      condicao: { campoId: 'rb_c13', operador: 'preenchido' },
      etapaDestinoId: 'rb_e4',
    },
    {
      tipo: 'exibir_ocultar',
      nome: 'Mostrar valor aprovado só quando aprovar',
      etapaOrigemId: 'rb_e2',
      condicao: { campoId: 'rb_c9', operador: 'igual', valor: 'Sim' },
      camposAfetadosIds: ['rb_c12'],
    },
  ],
  cards: [
    { id: 'rb_card1', titulo: 'Almoço com cliente - Projeto Alfa', etapaId: 'rb_e2', etiquetas: ['Cliente'], valores: { rb_c1: 'Marina Costa', rb_c2: 'Comercial', rb_c3: 187.5, rb_c4: 'Alimentação' } },
    { id: 'rb_card2', titulo: 'Combustível - visita técnica Campinas', etapaId: 'rb_e3', etiquetas: ['Viagem'], valores: { rb_c1: 'Rafael Souza', rb_c2: 'Operações', rb_c3: 320, rb_c4: 'Transporte / Combustível', rb_c12: 320 } },
    { id: 'rb_card3', titulo: 'Hotel - treinamento em SP', etapaId: 'rb_e4', etiquetas: ['Viagem'], valores: { rb_c1: 'Juliana Reis', rb_c2: 'RH', rb_c3: 640, rb_c4: 'Hospedagem', rb_c12: 640 } },
    { id: 'rb_card4', titulo: 'Cabo HDMI e adaptadores', etapaId: 'rb_e1', valores: { rb_c1: 'Pedro Lima', rb_c2: 'TI', rb_c3: 95, rb_c4: 'Material' } },
    { id: 'rb_card5', titulo: 'Jantar de equipe (sem comprovante)', etapaId: 'rb_e5', etiquetas: ['Fora da política'], valores: { rb_c1: 'Carlos Menezes', rb_c2: 'Comercial', rb_c3: 480, rb_c4: 'Alimentação', rb_c17: 'Sem nota fiscal anexada e acima do limite diário da política.' } },
  ],
  tour: [
    '🧾 Reembolso organizado: com comprovante, aprovação e prazo.',
    '📌 A política aparece dentro do próprio cartão — ninguém precisa procurar no e-mail.',
    '1️⃣ O colaborador registra a despesa. Comprovante é campo obrigatório.',
    '2️⃣ O gestor aprova ou recusa. Aprovou? o card vai sozinho para o financeiro.',
    '3️⃣ "Processamento": financeiro programa a data — a coluna mostra os mais antigos primeiro.',
    '4️⃣ "Reembolsado" com comprovante de transferência fecha o ciclo.',
    '💡 O campo "Valor Aprovado" só aparece quando o gestor aprova — reembolso parcial fica registrado.',
  ],
  etapasDicas: [
    { quemFaz: 'Colaborador que gastou', objetivo: 'Registrar a despesa com comprovante e justificativa enquanto a nota ainda existe.', automacoes: ['Comprovante é obrigatório — o card não avança sem ele'], conexoes: ['Ligue a Viagens Corporativas: a prestação de contas gera reembolsos aqui'], ondeConfigurar: 'Conexões entre Fluxos > Viagens > etapa "Prestação de Contas"' },
    { quemFaz: 'Gestor direto', objetivo: 'Conferir se a despesa cabe na política e liberar o valor (total ou parcial).', automacoes: ['Já configurado: aprovou vai ao financeiro, recusou vai para Recusado', 'Já configurado: "Valor Aprovado" só aparece quando aprovado'], ondeConfigurar: 'Automações > "Aprovado segue para o financeiro"' },
    { quemFaz: 'Financeiro / DP', objetivo: 'Programar o pagamento — avulso ou junto da folha.', ondeConfigurar: 'Configuração da Etapa > Ordenação dos cards' },
    { quemFaz: 'Financeiro', objetivo: 'Pagar e comprovar — encerra a pendência com o colaborador.', conexoes: ['Ligue a Contas a Pagar para o reembolso virar lançamento financeiro'], ondeConfigurar: 'Conexões entre Fluxos > Contas a Pagar' },
    { quemFaz: 'Colaborador (recebe de volta)', objetivo: 'Saber por que foi recusado e poder corrigir e reenviar.', ondeConfigurar: 'Configuração da Etapa > Transições permitidas' },
  ],
};

const fechamentoMensal: DefaultTemplate = {
  id: 'tpl_fechamento_mensal',
  name: 'Fechamento Contábil Mensal',
  descricao: 'Checklist mensal do fechamento: conciliação bancária, provisões, impostos, folha e entrega dos relatórios. Um cartão por competência, com prazo em cada bloco para nunca estourar a data do contador.',
  categoria: 'financeiro',
  icone: '📊',
  etiquetas: [
    { nome: 'Atrasado', cor: COR.vermelho },
    { nome: 'Auditoria', cor: COR.roxo },
    { nome: 'Fechado', cor: COR.verde },
  ],
  etapas: [
    {
      id: 'fm_e1', nome: 'Abertura da Competência',
      tempoMaximoHoras: 8,
      camposVisiveisNoCard: ['fm_c1', 'fm_c2'],
      permiteMoverPara: ['fm_e2'],
      campos: [
        { id: 'fm_c1', nome: 'Competência (MM/AAAA)', tipo: 'texto', obrigatorio: true, usarComoTitulo: true },
        { id: 'fm_c2', nome: 'Prazo de Entrega', tipo: 'data_vencimento', obrigatorio: true },
        { id: 'fm_c3', nome: 'Responsável pelo Fechamento', tipo: 'texto', obrigatorio: false },
        { id: 'fm_c4', nome: 'Observações da Competência', tipo: 'texto_longo', obrigatorio: false },
      ],
    },
    {
      id: 'fm_e2', nome: 'Conciliação Bancária',
      tempoMaximoHoras: 48,
      camposVisiveisNoCard: ['fm_c1', 'fm_c6'],
      permiteMoverPara: ['fm_e3'],
      permiteCriarCards: false,
      campos: [
        { id: 'fm_c5', nome: 'Contas Conciliadas', tipo: 'checkbox_multi', obrigatorio: true, opcoes: ['Banco Principal', 'Banco Secundário', 'Caixa', 'Cartão Corporativo', 'Conta de Investimento'] },
        { id: 'fm_c6', nome: 'Progresso da Conciliação', tipo: 'progresso', obrigatorio: false },
        { id: 'fm_c7', nome: 'Divergências Encontradas', tipo: 'texto_longo', obrigatorio: false },
        { id: 'fm_c8', nome: 'Extratos', tipo: 'anexo', obrigatorio: false },
      ],
    },
    {
      id: 'fm_e3', nome: 'Provisões e Lançamentos',
      tempoMaximoHoras: 48,
      camposVisiveisNoCard: ['fm_c1', 'fm_c9'],
      permiteMoverPara: ['fm_e4'],
      permiteCriarCards: false,
      campos: [
        { id: 'fm_c9', nome: 'Lançamentos Concluídos', tipo: 'checkbox_multi', obrigatorio: true, opcoes: ['Provisão de férias', 'Provisão de 13º', 'Depreciação', 'Despesas antecipadas', 'Receitas a apropriar'] },
        { id: 'fm_c10', nome: 'Valor Total Provisionado', tipo: 'valor', obrigatorio: false },
        { id: 'fm_c11', nome: 'Memória de Cálculo', tipo: 'anexo', obrigatorio: false },
      ],
    },
    {
      id: 'fm_e4', nome: 'Impostos e Obrigações',
      tempoMaximoHoras: 48,
      camposVisiveisNoCard: ['fm_c1', 'fm_c12'],
      permiteMoverPara: ['fm_e5'],
      permiteCriarCards: false,
      campos: [
        { id: 'fm_c12', nome: 'Guias Apuradas', tipo: 'checkbox_multi', obrigatorio: true, opcoes: ['DAS / Simples', 'ICMS', 'ISS', 'PIS/COFINS', 'IRPJ/CSLL', 'INSS / FGTS'] },
        { id: 'fm_c13', nome: 'Valor Total de Impostos', tipo: 'valor', obrigatorio: false },
        { id: 'fm_c14', nome: 'Guias', tipo: 'anexo', obrigatorio: false },
        { id: 'fm_c15', nome: 'Obrigações acessórias entregues?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
      ],
    },
    {
      id: 'fm_e5', nome: 'Relatórios Gerenciais',
      tempoMaximoHoras: 24,
      camposVisiveisNoCard: ['fm_c1', 'fm_c17'],
      permiteMoverPara: ['fm_e6'],
      permiteCriarCards: false,
      campos: [
        { id: 'fm_c16', nome: 'Relatórios Gerados', tipo: 'checkbox_multi', obrigatorio: true, opcoes: ['DRE', 'Balancete', 'Fluxo de Caixa', 'Análise por Centro de Custo'] },
        { id: 'fm_c17', nome: 'Resultado do Mês', tipo: 'valor', obrigatorio: false },
        { id: 'fm_c18', nome: 'Pacote de Relatórios', tipo: 'anexo', obrigatorio: false },
        { id: 'fm_c19', nome: 'Comentários da Análise', tipo: 'texto_longo', obrigatorio: false },
      ],
    },
    {
      id: 'fm_e6', nome: 'Competência Fechada',
      camposVisiveisNoCard: ['fm_c1', 'fm_c17'],
      permiteCriarCards: false,
      campos: [
        { id: 'fm_c20', nome: 'Data do Fechamento', tipo: 'data', obrigatorio: true },
        { id: 'fm_c21', nome: 'Aprovado pela Diretoria?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
      ],
    },
  ],
  automacoes: [
    {
      tipo: 'mover',
      nome: 'Obrigações entregues seguem para relatórios',
      etapaOrigemId: 'fm_e4',
      condicao: { campoId: 'fm_c15', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'fm_e5',
    },
  ],
  cards: [
    { id: 'fm_card1', titulo: '03/2026', etapaId: 'fm_e6', etiquetas: ['Fechado'], valores: { fm_c1: '03/2026', fm_c17: 128400 } },
    { id: 'fm_card2', titulo: '04/2026', etapaId: 'fm_e4', valores: { fm_c1: '04/2026', fm_c13: 41200 } },
    { id: 'fm_card3', titulo: '05/2026', etapaId: 'fm_e2', etiquetas: ['Atrasado'], valores: { fm_c1: '05/2026', fm_c6: 40 } },
    { id: 'fm_card4', titulo: '06/2026', etapaId: 'fm_e1', valores: { fm_c1: '06/2026' } },
  ],
  tour: [
    '📊 Um cartão por competência — o fechamento inteiro visível em uma tela.',
    '1️⃣ "Abertura": define a competência e o prazo de entrega ao contador.',
    '2️⃣ "Conciliação Bancária": marque cada conta conciliada e acompanhe a barra de progresso.',
    '3️⃣ "Provisões": férias, 13º, depreciação — tudo com checklist.',
    '4️⃣ "Impostos": guias apuradas e obrigações acessórias.',
    '5️⃣ "Relatórios": DRE, balancete e fluxo de caixa para a diretoria.',
    '⏱️ Com SLA em cada bloco, você descobre no Dashboard onde o fechamento sempre atrasa.',
  ],
  etapasDicas: [
    { quemFaz: 'Controladoria', objetivo: 'Abrir a competência com prazo definido — o relógio do SLA começa aqui.', ondeConfigurar: 'Configuração da Etapa > SLA' },
    { quemFaz: 'Analista Contábil', objetivo: 'Conciliar todas as contas e registrar divergências antes que virem erro no balanço.', automacoes: ['Use o campo Progresso para acompanhar o andamento sem abrir o cartão'], ondeConfigurar: 'Configuração da Etapa > Campos visíveis no card' },
    { quemFaz: 'Analista Contábil', objetivo: 'Lançar as provisões do mês com memória de cálculo anexada.', ondeConfigurar: 'Configuração da Etapa > Campos' },
    { quemFaz: 'Fiscal / Tributário', objetivo: 'Apurar guias e entregar obrigações acessórias no prazo legal.', automacoes: ['Já configurado: obrigações entregues movem o card para Relatórios'], conexoes: ['Ligue a Contas a Pagar para cada guia virar um pagamento programado'], ondeConfigurar: 'Automações > "Obrigações entregues seguem para relatórios"' },
    { quemFaz: 'Controladoria', objetivo: 'Fechar os números e entregar a leitura gerencial à diretoria.', ondeConfigurar: 'Configuração da Etapa > Campos' },
    { quemFaz: 'Diretoria', objetivo: 'Aprovar formalmente o fechamento — competência travada para auditoria.', ondeConfigurar: 'Configuração da Etapa > Permissões' },
  ],
};

export const TEMPLATES_FINANCEIRO: DefaultTemplate[] = [
  contasPagar,
  contasReceber,
  reembolsos,
  fechamentoMensal,
];
